class AddToCartSelect extends HTMLElement {
  constructor() {
    super()

    this.handleVariantChange = this.handleVariantChange.bind(this)
  }

  connectedCallback() {
    this.variantSelector = this.querySelector('.js-select-variant')
    this.variantsData = JSON.parse(this.querySelector('[data-variants-json]').innerHTML)
    this.variantImage = this.querySelector('.js-cart-upsell-item-image')
    this.abortController = new AbortController()

    if (!this.variantSelector) return

    this.variantSelector.addEventListener('change', this.handleVariantChange)
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  handleVariantChange() {
    const variantId = this.variantSelector.value
    this.dataset.variantId = variantId

    const variant = this.variantsData.find(v => `${v.id}` === variantId)
    const image = variant.featured_image

    if (image) {
      this.variantImage.src = window.__getSizedImageUrl__(image.src, 400)
    }
  }
}

customElements.define('add-to-cart-select', AddToCartSelect)